import React, { useEffect, useState } from "react";
import { Info, Phone } from "lucide-react";
import { Disclaimer } from "@/components/Disclaimer";
import { CustomerNav } from "@/components/CustomerNav";
import { getInstructions } from "@/lib/api";

export const STEPS = [
  { hi: "https://cincstock.in पर जाएं।", en: "Go to https://cincstock.in." },
  { hi: "अपना नाम, कंपनी का नाम और मोबाइल नंबर डालें।", en: "Enter your name, company name, and mobile number to log in." },
  { hi: "अपनी पसंद का फ़ैब्रिक टाइप चुनें।", en: "Choose the fabric type you need from the left side." },
  { hi: "अपनी पसंद का रंग चुनें।", en: "Select the color you want." },
  { hi: "ज़रूरी मात्रा डालें।", en: "Enter the quantity you need." },
  { hi: "Add बटन दबाएं। (अगर मात्रा स्टॉक में नहीं है तो 'Contact 8010307363 / 7020006164' का मैसेज दिखेगा।)", en: "Press the Add button. (If the quantity is not available, you will see a 'Contact 8010307363 / 7020006164' message.)" },
  { hi: "पूरा ऑर्डर जोड़ने के बाद ऊपर दाईं ओर Cart बटन दबाएं।", en: "Once done, press the Cart button on the top right." },
  { hi: "ऑर्डर देखें, बदलाव करें अगर ज़रूरी हो, और Submit दबाएं।", en: "Review your order, make changes if needed, and press Submit." },
  { hi: "हम आपसे Call या WhatsApp पर संपर्क करेंगे।", en: "We will contact you on Call or WhatsApp to confirm your order." },
  { hi: "रंगों का अंदाज़ा लेने के लिए आप Catalogs देख सकते हैं।", en: "You can view the Catalogs to get an idea of the colors." },
  { hi: "रंग के नाम के पास असली कपड़े की फ़ोटो भी देख सकते हैं। बस रंग पर क्लिक करें और वो बड़ा हो जाएगा।", en: "You can also view the actual fabric photo next to the color name. Just click on the color and it will expand." },
];

export function InstructionsBody({ steps = STEPS }) {
  return (
    <>
      <ol className="space-y-3" data-testid="instructions-list">
        {steps.map((s, i) => (
          <li key={i} className="flex gap-3 sm:gap-4 border border-white/10 bg-[#141414] p-4" data-testid={`instruction-step-${i + 1}`}>
            <span className="shrink-0 h-7 w-7 flex items-center justify-center bg-white text-black font-bold text-sm tabular">
              {i + 1}
            </span>
            <p className="text-sm sm:text-base leading-relaxed text-white/90">
              {s.hi && <span className="text-white">{s.hi}</span>}
              {s.en && <span className="text-white/45"> {s.hi ? "/ " : ""}{s.en}</span>}
            </p>
          </li>
        ))}
      </ol>

      <div className="mt-6 border border-amber-500/30 bg-amber-500/10 p-4" data-testid="instruction-note">
        <p className="text-sm sm:text-base leading-relaxed text-amber-200">
          <span className="font-bold">ध्यान रखें / Note:</span>{" "}
          <span className="text-amber-100">लॉगिन करते समय सही मोबाइल नंबर डालें।</span>
          <span className="text-amber-200/70"> / Please enter your correct mobile number while logging in.</span>
        </p>
      </div>

      <div className="mt-4 border border-white/10 bg-[#141414] p-4 flex items-center gap-3" data-testid="instruction-help">
        <Phone className="h-5 w-5 text-white/60 shrink-0" />
        <p className="text-sm sm:text-base text-white/90">
          <span className="font-bold">मदद के लिए / For help:</span>{" "}
          <a href="tel:8010307363" className="text-white underline hover:text-white/70">8010307363</a>
          <span className="text-white/40"> / </span>
          <a href="tel:7020006164" className="text-white underline hover:text-white/70">7020006164</a>
        </p>
      </div>
    </>
  );
}

export default function Instructions() {
  const [steps, setSteps] = useState(STEPS);

  useEffect(() => {
    getInstructions()
      .then((list) => { if (list && list.length) setSteps(list); })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <CustomerNav showBackHome />
      <Disclaimer />

      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-10">
        <p className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-3">Guide</p>
        <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tighter text-white flex items-center gap-3 mb-8">
          <Info className="h-7 w-7 text-white/60" />
          CiNCStock कैसे चलाएं
          <span className="text-white/40 font-bold text-2xl sm:text-3xl">/ How to Use</span>
        </h1>
        <InstructionsBody steps={steps} />
      </div>
    </div>
  );
}
